'use client';

import ReactMarkdown from 'react-markdown';

interface Props {
  content: string;
  className?: string;
}

export default function MarkdownRenderer({ content, className = '' }: Props) {
  return (
    <div className={`prose prose-invert prose-purple max-w-none ${className}`}>
      <ReactMarkdown
        components={{
          h1: ({ ...props }) => <h1 className="text-3xl font-serif font-bold mb-4 text-white italic" {...props} />,
          h2: ({ ...props }) => <h2 className="text-2xl font-serif font-bold mt-8 mb-4 text-purple-300 italic" {...props} />,
          h3: ({ ...props }) => <h3 className="text-xl font-serif font-bold mt-6 mb-2 text-purple-400 italic" {...props} />,
          p: ({ ...props }) => <p className="mb-4 text-slate-300 leading-relaxed italic" {...props} />,
          ul: ({ ...props }) => <ul className="list-disc list-inside mb-4 space-y-2 text-slate-300" {...props} />,
          li: ({ ...props }) => <li className="ml-4" {...props} />,
          strong: ({ ...props }) => <strong className="text-purple-200 font-bold" {...props} />,
          hr: () => <hr className="border-slate-800 my-8" />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
